import {i18n} from 'src/shared/config'

export const translations = {
  title: i18n(
    'banner.title.vertical-business',
    'Доставка со склада доступна только в кабинете для бизнеса',
  ),
  description: i18n('banner.description.vertical-business', {
    fallBackToKey: false,
  }),
  list: i18n('banner.list.vertical-business', {fallBackToKey: false}),
  imageSrc: i18n('banner.image-src.vertical-business', {fallBackToKey: false}),
}
